import './reset-password.css';
import api from "../../api";
import {useContext, useState} from "react";
import { UserContext } from "../../UserContext";
import { useToast } from "../../ToastContext";

function ResetPassword({ hide ,translate}) {

    const { user } = useContext(UserContext);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const { addToast } = useToast();


    const handleSubmit = async() => {
        // e.preventDefault();
        if (newPassword !== confirmPassword) {
            alert("New passwords does not match!");
            return;
        }
        try {
            const response = await api.post("user/reset-password", {
                currentPassword,
                newPassword,
            });
            addToast(translate("Password reset successfully!"),"success")
            hide();

        } catch (err) {
            alert(err.response?.data?.message);
            console.log(err.response?.data?.message || "Failed to reset password.");
        } finally {

        }
    };
    return (
        <>
            <div className="form">
            <div className="form-group">
                            <label>{translate("Current Password")}</label>
                            <input
                                type="password"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                required/>
            </div>
            <div className="form-group">
                            <label>{translate("New Password")}</label>
                            <input
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required/>
                        </div>
            <div className="form-group">
                            <label>{translate("Confirm New Password")}</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required/>
                        </div>
            <div className="modal-actions">
                            <button  className="red-white-btn" onClick={() => handleSubmit()} >{translate("Update Password")}</button>
                        </div>
            </div>
        </>
    );
}

export default ResetPassword;